<script setup lang="ts">
  import type { ChatMessage } from '@/composables/useChatStream'
  import SaveSnippetDialog from '@/components/app/chat/components/SaveSnippetDialog.vue'
  import { useTranslation } from '@/composables/useTranslation'
  import { Bookmark } from 'lucide-vue-next'
  import { ref } from 'vue'

  defineProps<{
    message: ChatMessage
  }>()

  const { t } = useTranslation({
    en: { save: 'Save' },
    de: { save: 'Speichern' },
    fr: { save: 'Enregistrer' }
  })

  const showSnippetDialog = ref(false)
</script>

<template>
  <div class="group flex items-center justify-end gap-2">
    <button
      type="button"
      class="inline-flex h-8 items-center gap-1.5 rounded-md px-2 text-sm font-normal text-gray-500 opacity-0
        transition-opacity hover:text-gray-700 focus-visible:opacity-100 group-hover:opacity-100"
      :aria-label="t('save')"
      @click="showSnippetDialog = true"
    >
      <Bookmark
        class="h-5 w-5"
        :stroke-width="1.5"
      />
      {{ t('save') }}
    </button>
    <div
      class="inline-flex max-w-64 items-center gap-2.5 rounded-2xl rounded-tr-none bg-primary px-4 py-2.5"
    >
      <p class="flex-1 text-sm font-normal leading-5 text-white font-inter">
        {{ message.content }}
      </p>
    </div>

    <SaveSnippetDialog
      v-if="showSnippetDialog"
      :content="message.content"
      @close="showSnippetDialog = false"
    />
  </div>
</template>
